import React, { useContext } from 'react';
import URI from 'urijs';
import { LAYER_NAME_UPSELL_ACTIVITIES } from 'Components/utils/layers/layers.constants';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { usePageContext } from 'Context/PageContext';
import { ServicesContext } from 'Context/ServicesContext';
import { useLayer } from 'Src/hooks/use-layer/useLayer';
import { t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ActivitiesThematicCard } from 'Components/widgets/activities-thematic-card/ActivitiesThematicCard';
import { RentalsCta } from 'Components/widgets/rentals-cta/RentalsCta';
function getPageName(
  pageMeta: any,
  siteSection: string,
  isProposal: boolean,
  pageId: string,
): string {
  if (pageMeta.resortId && siteSection) {
    return `${siteSection}_${pageMeta.resortId}`;
  }
  return isProposal ? 'BE_activities' : pageId;
}

type Props = {
  hasRentals?: boolean;
  isProposal?: boolean;
  layerName?: string;
  rentalsLayerName?: string;
  thematics: Array<ActivitiesThematicEntity>;
  trackRentals?: () => void;
};
export const ActivitiesThematics = ({
  hasRentals = false,
  isProposal = false,
  layerName,
  rentalsLayerName,
  thematics,
  trackRentals = () => {},
}: Props) => {
  const { trackingData } = useContext(ServicesContext);
  const { isTablet } = useResponsive();
  const isMobile = !isTablet;
  const { siteSection, pageMeta, pageId } = usePageContext();
  const itemsNumber = thematics.length + (hasRentals ? 1 : 0);
  const isTwoColumnsItem = (isMobile && itemsNumber % 2) === 0;
  const track = useTracking({
    actionGA: 'activities',
    siteSection,
    pageName: getPageName(pageMeta, siteSection, isProposal, pageId),
    ...trackingData,
  });
  const { nextUri } = useLayer(layerName || LAYER_NAME_UPSELL_ACTIVITIES, {
    type: 'THEMATICS',
  });

  const getUrl = (catId) =>
    new URI(nextUri)
      .addQuery({
        catId,
      })
      .toString();

  return (
    <section
      className="isolate grid grid-cols-2 gap-20 md:grid-cols-3"
      data-testid="Activities-all-componant"
    >
      {hasRentals && (
        <RentalsCta
          className="col-span-2 h-310"
          layerName={rentalsLayerName}
          onClick={trackRentals}
        />
      )}
      {thematics
        .filter((item) => (item.activities || []).length > 0)
        .map((item, index) => (
          <ActivitiesThematicCard
            className={classnames({
              'col-span-2': (!hasRentals && index === 0) || isTwoColumnsItem,
              'col-span-1': hasRentals || (index > 0 && !isTwoColumnsItem),
            })}
            firstItemDisplay={index > 0 && !hasRentals}
            key={item.id}
            label={t('common.activities.label')}
            onClick={() =>
              track({
                labelGA: `themes_${item.name}`,
              })
            }
            thematic={item}
            url={getUrl(item.id)}
          />
        ))}
    </section>
  );
};
